import { motion } from "framer-motion";
import { INDUSTRIES } from "@/components/vss/data";
import { Landmark, HeartPulse, Cpu, ClipboardList } from "lucide-react";

const ICONS = [Landmark, HeartPulse, Cpu, ClipboardList];

export default function Industries() {
  return (
    <section
      id="industries"
      className="relative py-28 sm:py-36 border-t border-slate-200"
      data-testid="industries-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 004 · Vertical Domain Expertise
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Tailored talent for
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                four regulated & scaled domains.
              </span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-5">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[i];
            return (
              <motion.article
                key={ind.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ delay: i * 0.08, duration: 0.7, ease: "easeOut" }}
                className="vss-card col-span-12 sm:col-span-6 lg:col-span-6 p-8 sm:p-10 flex gap-6 items-start"
                data-testid={`industry-card-${i}`}
              >
                <div className="hidden sm:flex h-14 w-14 rounded-2xl border border-teal-500/30 items-center justify-center bg-teal-50 shrink-0">
                  <Icon className="h-6 w-6 text-teal-600" />
                </div>
                <div>
                  <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700 mb-2">
                    {ind.tag}
                  </div>
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900">
                    {ind.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">
                    {ind.body}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
